import { render, staticRenderFns } from "./LabExamCard.vue?vue&type=template&id=58a4f868&scoped=true"
import script from "./LabExamCard.vue?vue&type=script&lang=js"
export * from "./LabExamCard.vue?vue&type=script&lang=js"
import style0 from "./LabExamCard.vue?vue&type=style&index=0&id=58a4f868&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a4f868",
  null
  
)

export default component.exports